import { styled } from '@stitches/configed';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Result } from '.';

const Container = styled('div', {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 16,
});

export default function Result404() {
  const navigate = useNavigate();
  return (
    <Container>
      <Result
        type="404"
        title="Đường dẫn hoặc trang không tìm thấy"
        message="Mình tìm muốn ốm luôn mà không thấy. Bạn kiểm tra lại địa chỉ hoặc đường dẫn nhé."
      >
        <Button
          type="primary"
          style={{ width: 254 }}
          onClick={() => navigate('/')}
        >
          Quay lại Trang chủ
        </Button>
      </Result>
    </Container>
  );
}
